import { Line } from "react-chartjs-2"
import styles from "./LineChart.module.css"
import useWindowSize from "@hooks/useWindowSize"
const LineChart = ({
    options1,
    chartData,
    options2,
    chartData2,
    boxRef,
    getBoxWidth,
}) => {
    const { width } = useWindowSize()

    return (
        <div className="bg-white rounded-lg p-6">
            {/* legeneds */}
            <div className="grid md:flex justify-end gap-6 mb-6 mr-8">
                {chartData?.datasets[1]?.label ? (
                    <div className="flex gap-4 items-center">
                        <div className="bg-[var(--bg-theme-primary)] w-12 h-4 rounded-sm"></div>
                        <span className="text-xs">
                            {chartData?.datasets[1]?.label}
                        </span>
                    </div>
                ) : null}

                {chartData?.datasets[0]?.label ? (
                    <div className="flex gap-4 items-center">
                        <div className="bg-[var(--primary-light-blue)] w-12 h-4 rounded-sm"></div>
                        <span className="text-xs">
                            {chartData?.datasets[0]?.label}
                        </span>
                    </div>
                ) : null}
            </div>

            <div
                className={styles.chartBox}
                style={width < 920 ? { width: `${width - 70}px` } : null}
            >
                <div className={styles.colSmall}>
                    <Line options={options2} data={chartData2} />
                </div>
                <div className={`${styles.colLarge} theme-scrollbar`}>
                    <div
                        className={styles.box}
                        style={{
                            width: `${getBoxWidth()}px`,
                            minWidth: "800px",
                        }}
                        ref={boxRef}
                    >
                        <Line options={options1} data={chartData} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LineChart
